import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { Overlay, Panel, ModalTitle } from './Modal.styles';

// Modal accesible con el estilo de la marca: Escape y clic fuera cierran,
// bloquea el scroll de la página y devuelve el foco al elemento que lo abrió.
// `onClose` puede ser null para un modal que no se descarta (p. ej. mientras guarda).
const Modal = ({ title, onClose, maxWidth, children, labelledBy = 'modal-title' }) => {
  const panelRef = useRef(null);
  const closeRef = useRef(onClose);
  closeRef.current = onClose;

  useEffect(() => {
    const previouslyFocused = document.activeElement;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    if (panelRef.current) panelRef.current.focus();

    const onKeyDown = (event) => {
      if (event.key === 'Escape' && closeRef.current) closeRef.current();
    };
    document.addEventListener('keydown', onKeyDown);

    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = previousOverflow;
      if (previouslyFocused && previouslyFocused.focus) previouslyFocused.focus();
    };
  }, []);

  // En un portal: así un modal abierto desde dentro de otro (p. ej. el de
  // actividades) no hereda su recorte ni su apilamiento.
  return createPortal(
    <Overlay onMouseDown={(e) => { if (e.target === e.currentTarget && onClose) onClose(); }}>
      <Panel
        ref={panelRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby={labelledBy}
        tabIndex={-1}
        $maxWidth={maxWidth}
      >
        {title && <ModalTitle id={labelledBy}>{title}</ModalTitle>}
        {children}
      </Panel>
    </Overlay>,
    document.body
  );
};

export default Modal;
